import { useWallet } from "@manahippo/aptos-wallet-adapter";
import { useSnackbar } from "notistack";
import { useState, useEffect, ReactNode, FC } from "react";

export const AptosSetup: FC<{ children: ReactNode }> = ({ children }) => {
  const { connect: connectAptos } = useWallet();
  const [initialLoad, setInitialLoad] = useState(true);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    /**
     * Adapter of PontemWallet {@link PontemWalletAdapter.onNetworkChange}  does not emit `accountChange` event when user chooses an account that is not connected
     * Fortunately native (window.pontem) object supports that
     */
    if (!window.pontem) {
      return;
    }

    window.pontem.onAccountChange((address) => {
      if (!address) {
        window.pontem?.connect();
      }
    });
  }, []);

  useEffect(() => {
    const lastAptosConnector = localStorage.getItem("lastAptosConnector");
    // There is not connectEagerly for Aptos so we need to track when rerender is not caused by page reload
    if (lastAptosConnector && initialLoad) {
      connectAptos(lastAptosConnector as any)
        .catch(() => {
          localStorage.removeItem("lastAptosConnector"); // failed to connectEagerly - do not try again
        })
        .finally(() => {
          setInitialLoad(false);
        });
    }
  }, [enqueueSnackbar, connectAptos, initialLoad]);

  return <>{children}</>;
};
